module.exports = __webpack_public_path__ + "static/media/deleteIcon.dda87834.svg";